import { createSelector } from '@ngrx/store';
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
export const getCalcs = createSelector(getChartState, ({ calcs }) => calcs);
export const hasCalcs = createSelector(getCalcs, (calcs) => {
    return calcs && !!calcs.length;
});
export const getCalcInfo = ({ calcInfo }) => calcInfo;
const hasEmptyCalcInfo = createSelector(getCalcInfo, (calcInfo) => Object.keys(calcInfo).length === 0);
export const isLoadingCalcs = createSelector(hasCalcs, hasEmptyCalcInfo, (_hasCalcs, _hasEmptyCalcInfo) => {
    return _hasCalcs && _hasEmptyCalcInfo;
});
